export const setKV = (k: string, v: string) => localStorage.setItem(k, v);
export const getKV = (k: string) => {
  try {
    return localStorage.getItem(k);
  } catch {
    return undefined;
  }
};
